import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { FilePathDetailModule } from './file-path-detail/file-path-detail.module';
import { FilePathTableRenderComponent } from './file-path-table-render.component';

@NgModule({
    declarations: [FilePathTableRenderComponent],
    exports: [FilePathTableRenderComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        FilePathDetailModule,
    ],
})
export class FilePathRenderModule { }
